import { Span } from '@pandiafi/design-system'
import React from 'react'

interface FeeTotalRowProps {
  label: string
  value: string
}

export const FeeTotalRow: React.FC<FeeTotalRowProps> = ({ label, value }) => (
  <div className="flex justify-between gap-4 py-2">
    <Span bold>{label}</Span>
    <Span bold large className="whitespace-nowrap">
      {value}
    </Span>
  </div>
)
